// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2dy5X","title":"FrontImage_title__1gGbI"};